export const Dispensing = {
  Header: {
    DispensingReservation: '調剤予約',
    ModifyReSubmit: '修正・再送信',
    DispensingReadyCalling: 'お薬できあがり呼出',
  },
  Message: {
    ExplanationMethod: 'お薬の説明方法をお選びください。',
    Reservation: '以下の情報を入力し、「予約する」を押してください。',
    DispensingReadyCalling:
      '以下の情報を入力し、「登録する」を押してください。',
    ReceiveMethod:
      'お薬の受取方法をお選びください。\r\n※配送は日本国内のみとなります。',
    OnlineModal:
      'お薬の内容によっては、薬局で対面によるお薬の説明が必要になる場合があります。',
    IsDigitalPrescription:
      '一部店舗では電子処方箋に対応しておりません。未対応店舗は「マイページ→その他→ヘルプ→よくある質問→未対応店舗」をご参照ください。',
    PrescriptionMethod: '処方箋のタイプをお選びください。',
    SelectPharmacy: '利用する薬局をお選びください。',
    Explanation: {
      Offline: '薬局（対面）で説明を受ける',
      Online: 'アプリで説明を受ける\r\n（オンライン服薬指導）',
    },
    Receive: {
      Store: '薬局（対面）でお受け取り',
      Delivery: '自宅でお受け取り',
    },
    Prescription: {
      Paper: '紙の処方箋',
      Digital: '電子処方箋',
    },
  },
  User: {
    Label: '患者さまのお名前',
  },
  Form: {
    name: {
      Label: '患者さまのお名前',
      ForeignNameAttention: '※外国籍の方は、ローマ字で入力して下さい。',
      LabelKana: 'お名前（カタカナ）',
      FirstName: '名',
      LastName: '姓',
      FirstNameKana: 'メイ',
      LastNameKana: 'セイ',
      birthday: '生年月日',
    },
    Gender: {
      Label: '性別',
      Male: '男性',
      Female: '女性',
    },
    Store: {
      Label: '薬局名',
    },
    PrescriptionPicture: {
      Label: '処方箋写真',
      Explanation: {
        Offline: 'お薬は処方箋原本と交換になります。必ずご持参下さい。',
        Online: {
          AttentionColorText:
            '薬局に処方箋原本を持参または郵送する場合、処方箋写真を添付してください。',
          DefaultColorText:
            '処方箋を医療機関より直接薬局へ送付される場合、処方箋写真は不要です。',
        },
      },
      LabelQr: 'QRコード読み取り',
      QrReadDone: 'QRコード読み取り済み',
      QrReadYet: 'QRコード未読み取り',
    },
    ExplanationMedicine: {
      Label: 'お薬の説明',
      Offline: '薬局でご説明',
      Online: 'ビデオ通話で説明を受ける（オンライン服薬指導）',
    },
    ReceivePlace: {
      Label: 'お薬の受け取り',
      OnStore: '薬局でのお受け取り',
      Delivery: '配送でのお受け取り',
      TodayBusinessHours: '営業時間:  ',
      BusinessHours: '営業時間:  ',
      RegularHoliday: '定休日:  ',
    },
    ExpectedDate: {
      Pharmacy: '薬局',
      Online: {
        Label: 'ビデオ通話予約日時',
        Text: '処方箋の使用期間「処方箋交付の日を含めて4日以内」でご予約ください。',
        ReceiveSoon: '今すぐ受け取りを希望',
        HowToReceive: 'お薬の受け取り',
        Delivery: '配送でのお受け取り',
        DeliveryAddress: '配送先住所',
        LeadToAddressSetting: '住所を設定してください。',
        AddressHint: '住所を設定してください。',
        PrescriptionPicture: '処方箋写真',
        SendPrescription:
          '医療機関より処方箋を薬局に送る場合は医療機関名を入力してください。',
        HospitalName: '医療機関名',
      },
      Offline: {
        Label: '来局希望日時',
        Text: '処方箋の使用期間「処方箋交付の日を含めて4日以内」でご予約ください。',
        ReceiveSoon: '今すぐ受け取りを希望',
      },
      Delivery: {
        Label: '配送希望日時',
        TextOnline: 'ビデオ通話予約日時を選んだ後にこちらは選択できます',
        TextOffline: '来局希望日時を選んだ後にこちらは選択できます',
      },
    },
    InsuranceCard: {
      Label: '健康保険情報の添付',
      PictureLabel: '保険者番号がわかる画像を添付',
      UseMynaLabel: 'マイナ保険証を利用する',
      UseMynaForDetailView: 'マイナ保険証を利用する\r\nマイナ在宅受付Web\r\n',
      UseMynaDetailAccept: '同意済み',
      UseMynaDetailCancel:
        '同意内容の照会、取消は以下のURLよりご確認ください。\r\n{0}\r\n※同薬局で他に予約がある場合は取消を行わないでください。',
      UseMynaNotice:
        '※外部サービス（マイナ在宅受付Web）へ遷移し、同意登録が必要になります。\r\n健康保険証利用登録済みのマイナンバーカードと対応端末をご準備ください。また、服薬指導日時までに同意登録がされていない場合、保険適用できない場合があります。',
      DisableMynaPharmacy:
        '※お選びいただいた薬局はマイナ保険証に対応していません。',
      MynaHomeCareWebNotSupported:
        '※お使いのアプリのバージョンではマイナ保険証をご利用できません。ストアで最新のバージョンにアップグレードしてください。',
    },
    GenericMedicine: {
      Label: 'ジェネリック医薬品を希望されますか？',
      Yes: '希望する',
      No: '希望しない',
      Consult: '薬剤師に相談したい',
    },
    Payment: {
      Label: '支払方法',
      Online: 'オンライン決済',
      Offline: '薬局で支払',
      Settings: 'カードを編集する',
      CardNumber: 'カード番号',
      ExpiredDate: 'カード有効期限',
    },
    Phone: {
      Label: 'ご連絡先の電話番号',
      Hint: '電話番号',
    },
    Qa: {
      Label: 'お薬アンケート（任意）',
      Answer: '回答する',
      BeforeMedicine: '前回のお薬',
      Condition: '体調',
      SideEffects: '副作用',
      Remaining: '残薬',
    },
    Memo: {
      Label: 'その他のご連絡・ご要望事項（任意）',
      Hint: '500文字以内でご入力ください。',
    },
    AboutGeneric: {
      Title: 'ジェネリック医薬品とは',
      Content:
        'ジェネリック医薬品は、新薬（先発医薬品）と同じ有効成分を使っており、品質、効き目、安全性が同等なおくすりです。厳しい試験に合格し、厚生労働大臣の承認を受け、国の基準、法律に基づいて製造・販売しています。さらに、製品によっては、服薬しやすいように大きさや味・香りなどを改良したジェネリック医薬品もあります。新薬に比べ開発費が少ないために、新薬より低価格なおくすりです。',
    },
    ElectronicPrescription: {
      Title: 'お薬の引換情報（電子処方箋）',
      ExchangeNumber: '引換番号',
      InsuredNumber: '被保険者番号（記号を除く）',
    },
    Question: {
      BeforeMedicine: {
        text: '前回もらったお薬はお使いになりましたか？',
        Yes: 'はい、使っていました',
        No: 'いいえ、使っていないです',
        First: '今回が初めてお薬をもらいます',
        Neither: 'どちらともいえない',
      },
      Condition: {
        text: 'お薬をお使いの際、体調は如何でしたか？睡眠や食欲、おなかの調子に変わりはありましたか？',
        Good: 'あった',
        Bad: '悪くなった',
        NoEffect: '変わらない',
        Neither: 'どちらとも言えない',
      },
      SideEffects: {
        text: '気分が悪くなったり、かえって余計にひどくなったりなど副作用のようなたいけんはありましたか？',
        Yes: 'あった',
        No: 'なかった',
        Neither: 'どちらともいえない',
      },
      Remaining: {
        text: '前回もらったお薬の余りは有りますか？できればご持参ください。',
        Yes: 'はい、あります',
        No: 'いいえ、ありません',
        Neither: 'わからない',
      },
    },
    Validation: {
      ErrorMessage: '入力エラーがあります。',
      emptyCreditCard: 'クレジットカードが登録されていません。',
      InvalidInput: '無効な入力値です。',
      InvalidBirthDay: '120年前～本日までの日付を選択してください。',
      NotNumericOrHyphen: '半角数字またはハイフンを入力してください。',
    },
    Confirm: {
      PrescriptionPicture: '送付処方箋画像確認',
      Retake: '撮り直し',
      Delete: '削除',
      Back: '戻る',
    },
    ConfirmationDialog: {
      Text: 'ご利用者様のお名前と処方箋、保険情報のお名前が合っていますか？',
      ReadyCallingReservationText: 'ご利用者様のお名前が合っていますか？',
      Ok: 'OK',
      Revise: '修正する',
    },
    ModifyReSubmit: {
      Image: '画像が不鮮明なため、写真を撮り直して再送信してください。',
      HospitalName: '医療機関名をご確認の上、再送信してください。',
      ElectronicPrescription:
        'お薬の引換情報をご確認の上、再送信してください。',
      ReSubmit: '再送信',
    },
    WarningDialog: {
      Text: '追加した写真を本当に削除しますか？',
      Delete: '削除する',
      Cancel: 'キャンセル',
    },
    CannotReserve: {
      Text: '現在この薬局では予約できません。',
      Ok: 'OK',
    },
    MynaInsuFailed: {
      Title: 'マイナ保険証の同意登録時にエラーが発生しました。',
      Text:
        '以下の原因が考えられますので、ご確認の上再度実施してください。\r\n' +
        '・お使いのマイナンバーカードに保険情報が正しく紐づけられていない\r\n' +
        'ステータスコード：{0}',
      CodeSplit: '：',
    },
    Reserve: '予約する',
    Regist: '登録する',
    Change: '変更する',
    AddPicture: '写真を追加',
    To: '～',
    Comma: '、',
  },
  ReservationDetail: {
    ExplanationMethod: {
      Online: 'ビデオ通話で説明を受ける',
      Offline: '薬局で説明を受ける',
    },
    ReceiveMethod: {
      Delivery: '配送でお受け取り',
      Offline: '薬局でお受け取り（来局）',
    },
  },
};
